var React = require('react');

function OH (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M59.6 26.48l-0.56-22.32-10.4 4.48-4.8 3.92-3.68-0.16-5.28 1.92-1.2-0.24-1.68-1.36 0.96 1.040-2.32-0.72-1.6 0.72-1.68-0.64 4.48-0.72-1.92-1.36-0.48 0.88-1.28-0.080-1.2-1.36-4.72-1.84-16.8 0.16-1.44 43.52 1.36-0.8 1.2 1.2 2.24-0.4 1.92 1.52 1.2 3.28 1.68 0.88 1.44-0.16 1.36 0.32 2 2.24h0.88l0.32-0.72 1.36-0.48 2.080 0.88 0.72 0.96 2-0.16 1.6-1.68 1.68-0.56 1.040 2.64 1.68 0.96 1.28 1.92 3.52-0.48 0.56-2.4 1.52-0.4-0.48-2.88 2-3.6 0.72-0.32 0.72 0.48 0.64 1.92 0.88-1.36 0.88 0.16-0.24-1.6-0.64-0.8 0.88-0.24v-1.2l0.96-1.68h1.28l0.32-1.2 1.2-1.040h0.64l0.72 1.040 1.84-0.88 4.48-3.92 0.4-1.68-0.4-0.88 0.88-1.68-0.16-0.88h0.64l0.16-2.56 1.6-4-0.32-1.040 0.32-1.84-0.88-1.68z"}));
}

OH.defaultProps = {"version":"1.1","width":"64","height":"80","viewBox":"0 0 64 80"};

module.exports = OH;

OH.default = OH;
